// extracted by mini-css-extract-plugin
module.exports = {"width":"1450px"};